import { Injectable } from '@angular/core';
import { flare } from '@flareapp/js';
import { LoginService } from '../data/login.service';
import { AppUser } from '../models/app.user';

@Injectable({ providedIn: 'root' })
export class FlareUserContextService {
  constructor(private loginService: LoginService) {}

  init(): void {
    flare.configure({ version: this.loginService.version });

    this.loginService.loggedUser$.subscribe((user: AppUser | null) => {
      if (user && user.id) {
        flare.addContextGroup('user', {
          id: user.id,
          email: user.email ?? null,
          name: user.name ?? null,
        });
      } else {
        flare.addContextGroup('user', {});
      }
    });
  }
}
